import { Flex } from 'components/Flex';
import { useFetchJaneByIdDataContext } from 'modals/JaneDetailsModal/FetchJaneById.data.context';
import { JaneName } from 'modals/JaneDetailsModal/views/JaneDetailsView/ReviewsTab/ReviewsTab.styled';
import {
  ColorDot,
  TimeWrapper,
  FlexWrapper,
  ActivityContentWrapper,
  TextWrapper,
} from 'modals/JaneDetailsModal/views/JaneDetailsView/ActivityTab/ActivityTab.styled';
import { Fragment } from 'react';
import { SectionDivider } from 'modals/ShiftModal/ShiftModal.styled';
import { humanReadableDate } from 'modals/JaneDetailsModal/JaneDetailsModal.constants';
import {
  LoadingWrapper,
  Text,
} from 'modals/JaneDetailsModal/views/JaneDetailsView/GeneralTab/GeneralTab.styled';
import {
  Activity,
  auditEvents,
  getActivityColorByEvent,
} from 'modals/JaneDetailsModal/views/JaneDetailsView/ActivityTab/ActivityTab.types';
import i18next from 'i18next';
import { BKJLoadingSpinner } from '@bookjane2/bookjane-design-library';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';
import { InfiniteScrollLoading } from 'components/InfiniteScrollLoading';
import { useSelector } from 'react-redux';
import isUserTimeFormat24hSelector from 'store/selectors/userSelectors/isUserTimeFormat24hSelector';

export const ActivityTab = () => {
  const { data, activities, isLoading, activitiesMeta, fetchNextPageActivities } =
    useFetchJaneByIdDataContext();
  const isUserTimeFormat24h = useSelector(isUserTimeFormat24hSelector);

  const hasNextPage =
    activitiesMeta?.current_page &&
    activitiesMeta?.total_pages &&
    activitiesMeta.current_page < activitiesMeta.total_pages;

  const location = getCurrentlySelectedLocation();
  if (!data)
    return (
      <LoadingWrapper>
        <BKJLoadingSpinner variant="Default" />
      </LoadingWrapper>
    );
  const { shorthandName = '' } = data;
  return (
    <Fragment>
      <FlexWrapper>
        <Flex flexDirection="column" width="100%">
          <JaneName>{shorthandName}</JaneName>
          <SectionDivider variant="Thin" />
        </Flex>
        <Flex flexDirection="column" width="100%" gap="32px">
          {activities?.length > 0 ? (
            activities.map((item: Activity) => (
              <ActivityContentWrapper key={item.id}>
                <TimeWrapper>
                  {humanReadableDate(item?.created_at, location?.timeZone, isUserTimeFormat24h)}
                </TimeWrapper>
                <Flex gap="6px" width="100%">
                  <ColorDot color={getActivityColorByEvent(item?.event)}>•</ColorDot>
                  <TextWrapper>
                    {auditEvents(item?.event, item?.feedable?.shift_ids[0])}
                  </TextWrapper>
                </Flex>
              </ActivityContentWrapper>
            ))
          ) : (
            <Flex height="581px" justifyContent="center" alignItems="center">
              <Text>{i18next.t('team_member:THERE_IS_NO_ACTIVITY')}</Text>
            </Flex>
          )}
          {hasNextPage && !isLoading && (
            <Flex
              justifyContent="center"
              alignItems="center"
              width="100%"
              padding="24px 0px 0px 0px"
            >
              <InfiniteScrollLoading onViewportEnter={fetchNextPageActivities} />
            </Flex>
          )}
        </Flex>
      </FlexWrapper>
    </Fragment>
  );
};
